import { ACTIVATE_EMAIL_PATH, FORGOTTEN_PASSWORD_PATH, LANDING_PATH, LOGIN_PATH, PAYMENT_SUCCESSFUL_PATH, REGISTER_PATH } from 'components/RouterSharedPaths'
import {
  Auth,
  CookiePolicy,
  EmailActivation,
  Landing,
  LegalNotice,
  Me,
  Payment,
  PaymentSuccessful,
  PersonalData,
  ResetPassword,
  TermsOfUse,
  ThreeDSReturn,
} from 'pages'
import {
  Presentation,
  Team,
  Training,
  TrainingSpace,
} from 'pages/dpc'
import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom'

export const routes = [
  {
    element: (<Landing />),
    path: LANDING_PATH,
  },
  {
    element: (<Auth />),
    path: LOGIN_PATH,
  },
  {
    element: (<Auth />),
    path: REGISTER_PATH,
  },
  {
    element: (<Auth />),
    path: `${REGISTER_PATH}/:invitationToken`,
  },
  {
    element: (<EmailActivation />),
    path: `${ACTIVATE_EMAIL_PATH}`,
  },
  {
    element: (<Auth />),
    path: FORGOTTEN_PASSWORD_PATH,
  },
  {
    element: (<Payment />),
    path: '/payment',
  },
  {
    element: (<PaymentSuccessful />),
    path: PAYMENT_SUCCESSFUL_PATH,
  },
  {
    element: (<TermsOfUse />),
    path: '/terms-of-use',
  },
  {
    loader: async () => redirect('/terms-of-use'),
    path: '/terms-of-service-app',
  },
  {
    element: (<PersonalData />),
    path: '/privacy-policy',
  },
  {
    element: (<CookiePolicy />),
    path: '/cookie-policy',
  },
  {
    element: (<LegalNotice />),
    path: '/legal-notice',
  },
  {
    element: (<Me />),
    path: '/me/*',
  },
  {
    element: (<ResetPassword />),
    path: '/reset-password/:token',
  },
  {
    element: (<ThreeDSReturn />),
    path: '/3dsreturn',
  },
  {
    element: (<Presentation />),
    path: '/dpc',
  },
  {
    element: (<Training />),
    path: '/dpc/training',
  },
  {
    element: (<Team />),
    path: '/dpc/team',
  },
  {
    element: (<TrainingSpace />),
    path: '/dpc/training-space',
  },
]

export const router = createBrowserRouter(
  routes,
)

const Router = () => {
  return (<RouterProvider router={router} />)
}

export default Router
